import {useNotify, useRecordContext} from "ra-core";
import {Button} from "ra-ui-materialui";
import React from "react";
import {client} from "../dataProvider";
import {Badge, CircularProgress} from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Print";
import BlockIcon from '@material-ui/icons/Block';
import {ButtonProps,} from "react-admin";


export const PrintRouteZipButton = (props: ButtonProps) => {
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();
  const record = useRecordContext();
  const handleSubmit = async () => {
    setLoading(true);
    let response = client(
      `routes/${record.id}/set_print_route_zip_with_qr_get`, {
      method: "GET",
    }
    ).then((response) => {
      if (response.done !== true) {
        notify("Errore durante la stampa", { type: "error" });
      } else {
        notify("Stampa in corso", { type: "info" });
      }
      setLoading(false);
      return response;
    });

  };
  const handleBlockSubmit = async () => {
    setLoading(true);
    let response = client(
      `routes/${record.id}/block_print`, {
      method: "GET",
    }
    ).then((response) => {
      if (response.done !== true) {
        notify("Errore durante il blocco stampa", { type: "error" });
      } else {
        notify("Stampa bloccata", { type: "info" });
      }
      setLoading(false);
      return response;
    });

  };

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : (
        record.printed_status === 'Non stampato' ? <Button
          {...props}
          disabled={loading}
          label="Stampa A5"
          title="Stampa A5"
          onClick={handleSubmit}
        >
          <PublishIcon />
        </Button> : 
          record.printed_status === 'Stampato' ? 
            <Badge style={{ marginLeft: "60px"}} badgeContent={record.printed_status} color="primary"/> :
            <Button
              {...props}
              disabled={loading}
              label="Blocca stampa"
              title="Blocca stampa"
              onClick={handleBlockSubmit}>
                <BlockIcon />
            </Button>
      )}
    </>
  );
};
